import React from 'react';

const managementKpiMarkup = String.raw`<div class="card inline-style-33" id="mgmtDetailPanel">
<div class="card-head"><p class="card-title" id="mgmtDetailTitle">Detail</p><span class="reset-tag" onclick="mgmtCloseDetail()">Close ✕</span></div>
<div id="mgmtDetailBody"></div>
</div>`;

export default function ManagementKpiDrilldown() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: managementKpiMarkup }} />;
}
